import { ColumnFilter, LookupTableMemberDefinition, PostTestCaseDto } from '../../generated-service-lib';
import { GeneratedTestCaseService } from '../generatedServices';
import { assertSuccessfulResponse, getValidResponseDataOrEmptyArray, getValidResponseDataOrThrow } from '../helpers';
import { KeyValuePair, LookupTable, LookupTableArrayView } from '../types';

export class TestCaseService {
  readonly unvalidatedClient: GeneratedTestCaseService;
  constructor(domain?: string) {
    this.unvalidatedClient = new GeneratedTestCaseService(domain);
  }

  public getTestCases = async (clientId: string) => {
    const response = await this.unvalidatedClient.getClientsByClientIdTestCases({
      clientId,
    });
    if (!response.ok) throw new Error();
    return response.body;
  };

  public postTestCases = async (clientId: string, testCases: PostTestCaseDto[]) => {
    const response = await this.unvalidatedClient.postClientsByClientIdTestCases({
      clientId,
      body: testCases,
    });
    if (!response.ok) throw new Error();
    return response.body;
  };
}
